// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Paginado_pagination__1y3TB","containerPagination":"Paginado_containerPagination__3UgsU"};